import React, { Component } from "react";
import { Col, Row, Collapse } from "reactstrap";
import {
  groupContentFields,
  groupERGcategories,
  groupPrivacyStatusDesc,
  groupRoles,
  grpBannerImg,
} from "../../../utils/constants";
import SingleEvent from "./SingleEvent";

export default class GroupInfoMobileUI extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapseOpen: 0,
    };
  }
  render() {
    const {
      group,
      user,
      menu,
      stories_url,
      groupLength,
      goToMembersPage,
      grpHomePage,
    } = this.props;
    let { privacy } = group;
    const { collapseOpen } = this.state;

    // console.log('invitedUsers: ', invitedUsers)
    let grp_img =
      group && group.bannerImg && group.bannerImg.url
        ? group.bannerImg.url
        : grpBannerImg;
    return (
      <div className="group-info-mobile-wrapper p-3">
        <div className="group-details-mobile-div">
          <Row>
            <Col xs={3}>
              <img className="mobile-group-info-img" src={grp_img} />
            </Col>
            <Col xs={9} className="px-0">
              <p
                className={`font-weight-bold mt-2 ml-2 cursor-pointer`}
                onClick={() => grpHomePage()}
              >
                {group.name}
              </p>
              <span className="text-secondary">
                {" "}
                {privacy != null
                  ? groupContentFields(privacy)["name"]
                  : "Group Status"}
              </span>
              <span
                className="grp_create_page_member_count"
                onClick={() => goToMembersPage()}
              >
                {" "}
                {groupLength} members
              </span>
            </Col>
          </Row>

          <div className="my-2">{group.description}</div>

          <div className="mb-2">
            {(group && group.categories.length > 0) ||
            (group &&
              group.groupOwner &&
              group.groupOwner._id == user.profile._id) ? (
              <div className="grp_single_page_grp_categories grp_right_side_menu_padding mb-0">
                <span className="grp_create_page_privacy_status_details title">
                  Categories
                </span>
                <span className="grp-cat-mobile">
                  {group && group.categories.length > 0 ? (
                    group.categories.map((e, idx) => {
                      return (
                        <span
                          className="grp-mobile-cat"
                          style={{
                            paddingRight:
                              e._id == "template_other_01" ? "0px" : "",
                          }}
                          key={idx}
                        >
                          <span
                            className="grp_story_template"
                            style={{
                              backgroundColor: groupERGcategories.filter(
                                g => g.id == e.id
                              )[0].color,
                              border: groupERGcategories.filter(
                                g => g.id == e.id
                              )[0].border,
                            }}
                          >
                            <img src={e.image} className="grp_template_image" />
                            {e.name}
                          </span>
                        </span>
                      );
                    })
                  ) : (
                    <span className="go_to_grp_settings">
                      Please go to{" "}
                      <span
                        className="go_to_grp_settings_btn"
                        onClick={() => this.goToPage("ST")}
                      >
                        Group Settings
                      </span>{" "}
                      to select categories.
                    </span>
                  )}
                </span>
              </div>
            ) : null}
          </div>
        </div>
        {this.props.location.pathname == stories_url ? (
          <span className="grp_mobile_ui_info_tabs">
            <div className="grp_single_page_privacy_status_info">
              <span
                className="grp_create_page_privacy_status_details title cursor-pointer grp_mobile_ui_tabitem"
                onClick={() =>
                  this.setState({ collapseOpen: collapseOpen == 1 ? 0 : 1 })
                }
              >
                About
              </span>
              <Collapse isOpen={collapseOpen === 1}>
                <span className="grp_create_page_privacy_status_details description">
                  {group.description}
                </span>
                {group.privacy ? (
                  <span className="grp_create_page_privacy_status_details option">
                    {groupContentFields(privacy).name}
                    <span> {groupContentFields(privacy).description} </span>
                    <span> {groupContentFields(privacy).permission} </span>
                  </span>
                ) : (
                  <span>
                    {groupPrivacyStatusDesc.map((e, idx) => {
                      return (
                        <span
                          className="grp_create_page_privacy_status_details option"
                          key={idx + e.id}
                        >
                          {e.name}
                          <span> {e.description} </span>
                        </span>
                      );
                    })}
                  </span>
                )}
              </Collapse>

              {group && group._id ? (
                <div className="grp_single_page_grp_categories mt-1">
                  <span
                    className="grp_create_page_privacy_status_details title cursor-pointer grp_mobile_ui_tabitem"
                    onClick={() =>
                      this.setState({ collapseOpen: collapseOpen == 2 ? 0 : 2 })
                    }
                  >
                    Upcoming Events
                  </span>
                  <Collapse isOpen={collapseOpen === 2}>
                    <SingleEvent group={group} />
                  </Collapse>
                </div>
              ) : null}
            </div>
          </span>
        ) : menu == "M" ? (
          <span className="grp_single_detail_page_container_rmenu_members">
            <div className="grp_single_page_privacy_status_info">
              <span
                className="cursor-pointer grp_single_detail_page_container_rmenu_members_title grp_mobile_ui_tabitem"
                onClick={() =>
                  this.setState({ collapseOpen: collapseOpen == 1 ? 0 : 1 })
                }
              >
                Group Member Roles
              </span>
              <Collapse isOpen={collapseOpen === 1}>
                {groupRoles.map(e => {
                  if (e.isHidden != true) {
                    return (
                      <div className="grp_single_detail_page_container_rmenu_members_itm">
                        <span className="grp_single_detail_page_container_rmenu_members_label">
                          {e.label}
                        </span>
                        <span className="grp_single_detail_page_container_rmenu_members_description">
                          {e.description}
                        </span>
                      </div>
                    );
                  }
                })}
              </Collapse>
            </div>
          </span>
        ) : null}
      </div>
    );
  }
}
